import { useMutation } from "@tanstack/react-query";
import { getCoreAxiosInstance } from "../../api/CoreAxiosInstance";
import type { AgentInvocationRequest } from "../types";

interface TriggerRunResponse {
  workflow_id: string;
}

export function useTriggerShadowRun(agentId: string) {
  return useMutation<TriggerRunResponse, Error, AgentInvocationRequest>({
    mutationFn: async (request: AgentInvocationRequest) => {
      const instance = await getCoreAxiosInstance();
      const { data } = await instance.post<TriggerRunResponse>(
        `/api/v1/agents/${agentId}/invocations`,
        request,
      );
      return data;
    },
  });
}
